var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DialogUpdateNote__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._v("עדכון משימה ")]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogUpdateNote__Component__Loading" },
          [
            _c("FieldInlineDateTime", {
              attrs: {
                label: "עד תאריך",
                "hide-hover": true,
                position: "is-bottom-left"
              },
              on: { onChange: _vm.onChange },
              model: {
                value: _vm.DueDate,
                callback: function($$v) {
                  _vm.DueDate = $$v
                },
                expression: "DueDate"
              }
            }),
            _c("FieldInlineDateTime", {
              attrs: {
                label: "תזכורת",
                "hide-hover": true,
                position: "is-bottom-left"
              },
              on: { onChange: _vm.onChange },
              model: {
                value: _vm.EmailReminderDate,
                callback: function($$v) {
                  _vm.EmailReminderDate = $$v
                },
                expression: "EmailReminderDate"
              }
            }),
            _c(
              "b-field",
              {
                attrs: {
                  label: "הערה",
                  type: !_vm.isValidReference ? "is-danger" : "",
                  message: !_vm.isValidReference ? "יש להזין הערה" : ""
                }
              },
              [
                _c("b-input", {
                  model: {
                    value: _vm.note,
                    callback: function($$v) {
                      _vm.note = $$v
                    },
                    expression: "note"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary"
            },
            on: { click: _vm.save }
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }